/* eslint-disable @typescript-eslint/no-explicit-any */
export class APIError extends Error {
	public readonly statusCode: number;

	public readonly message: string;

	public readonly errorCode?: any;

	public readonly headers?: Record<string, string>;

	constructor(
		statusCode: number,
		message: any,
		errorCode?: any,
		headers?: Record<string, string>,
	) {
		super();
		this.statusCode = statusCode;
		this.message = message?.detail ?? '';
		this.errorCode = errorCode;
		this.headers = headers;
	}
}
